import { render, staticRenderFns } from "./hjVideo.vue?vue&type=template&id=25c92e9f"
import script from "./hjVideo.vue?vue&type=script&lang=js"
export * from "./hjVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports